// extracted by mini-css-extract-plugin
export default {"formHeading":"xM-z","form":"yM-z","submitBtn":"zM-z","disabled":"AM-z","input":"BM-z","error":"CM-z","submitMsg":"DM-z","signIn":"EM-z"};